import React, { useState } from "react";
import { Form, Input, Modal, Radio, message } from "antd";
import { sendHelpToRDStation } from "@/service/rdstation";
import { MASKS, RULES } from "@/utils/formRules";

interface FeedbackModalProps {
  open: boolean;
  onClose: () => void;
  defaultName?: string;
  defaultEmail?: string;
}

interface FeedbackForm {
  nome: string;
  email: string;
  telefone: string;
  assunto: string;
  mensagem: string;
}

const SUBJECTS = [
  "Relatar problema",
  "Sugestões e melhorias",
  "Ajuda e suporte técnico",
  "Outro",
];

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  open,
  onClose,
  defaultName,
  defaultEmail,
}) => {
  const [form] = Form.useForm<FeedbackForm>();
  const [sending, setSending] = useState(false);

  const submit = async (values: FeedbackForm) => {
    setSending(true);
    try {
      const result = await sendHelpToRDStation(values);
      if (!result.success) {
        message.error(result.message || "Não foi possível enviar sua mensagem.");
        return;
      }
      message.success("Mensagem enviada com sucesso!");
      form.resetFields();
      onClose();
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal
      title="Feedback do sistema"
      open={open}
      onCancel={onClose}
      onOk={() => form.submit()}
      okText="Enviar"
      cancelText="Cancelar"
      confirmLoading={sending}
      width={560}
      destroyOnClose
    >
      <p style={{ marginBottom: 16, color: "#5a646e" }}>
        Relate problemas, peça ajuda ou envie sugestões sobre a Yuha!.
      </p>
      <Form<FeedbackForm>
        form={form}
        layout="vertical"
        requiredMark={false}
        onFinish={submit}
        initialValues={{ nome: defaultName, email: defaultEmail, telefone: "+55" }}
      >
        <Form.Item name="nome" label="Nome" rules={[{ required: true, message: "Informe seu nome." }]}>
          <Input placeholder="Digite seu nome" />
        </Form.Item>
        <Form.Item
          name="email"
          label="E-mail"
          rules={[
            { required: true, message: "Informe seu e-mail." },
            { type: "email", message: "Digite um e-mail válido." },
          ]}
        >
          <Input placeholder="Digite seu e-mail" />
        </Form.Item>
        <Form.Item
          name="telefone"
          label="Telefone"
          getValueFromEvent={MASKS.intlPhone}
          rules={RULES.intlPhone}
        >
          <Input type="tel" maxLength={19} autoComplete="tel" placeholder="+55 (11) 99999-8888" />
        </Form.Item>
        <Form.Item name="assunto" label="Assunto" rules={[{ required: true, message: "Escolha um assunto." }]}>
          <Radio.Group options={SUBJECTS} />
        </Form.Item>
        <Form.Item name="mensagem" label="Mensagem" rules={[{ required: true, message: "Escreva sua mensagem." }]}>
          <Input.TextArea rows={4} placeholder="Digite sua mensagem" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FeedbackModal;
